const receipts = {
  state: {
    pageType: 'list',
    beginUpdate: new Date(),
    receiptId: null
  },
  mutations: {
    set_receipt_pageType (state, data) {
      state.pageType = data
    },
    set_receipt_update (state, data) {
      state.beginUpdate = data
    },
    set_receipt_receiptId (state, data) {
      state.receiptId = data
    }
  },
  getters: {

  },
  actions: {

  }
}
export default receipts
